'use strict';

exports.__esModule = true;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactRouterDom = require('react-router-dom');

var _datosLocalesHelper2 = require('../helpers/datosLocalesHelper');

var _logo = require('./logo.png');

var _logo2 = _interopRequireDefault(_logo);

var _avatar = require('./avatar.png');

var _avatar2 = _interopRequireDefault(_avatar);

require('./cabecera.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Cabecera = (_temp = _class = function (_Component) {
  _inherits(Cabecera, _Component);

  function Cabecera() {
    _classCallCheck(this, Cabecera);

    var _this = _possibleConstructorReturn(this, _Component.call(this));

    _this.state = {};
    return _this;
  }

  Cabecera.prototype.onTopbarItemClick = function onTopbarItemClick(event, item) {
    if (this.props.onTopbarItemClick) {
      this.props.onTopbarItemClick({
        originalEvent: event,
        item: item
      });
    }
  };

  Cabecera.prototype.render = function render() {
    var _this2 = this;

    var _datosLocalesHelper = (0, _datosLocalesHelper2.datosLocalesHelper)(),
        tokenSeps = _datosLocalesHelper.tokenSeps,
        sistemaSeps = _datosLocalesHelper.sistemaSeps,
        nsistemasSeps = _datosLocalesHelper.nsistemasSeps,
        norgSeps = _datosLocalesHelper.norgSeps,
        orgSeps = _datosLocalesHelper.orgSeps;

    var mostrarCambiosSistemas = nsistemasSeps && nsistemasSeps > 1;
    var mostrarOrganizacion = norgSeps && norgSeps > 0;
    var topbarItemsClassName = (0, _classnames2.default)('topbar-items fadeInDown', {
      'topbar-items-visible': this.props.topbarMenuActive
    });
    return _react2.default.createElement('div', {
      className: 'topbar clearfix'
    }, _react2.default.createElement('div', {
      className: 'topbar-left'
    }, _react2.default.createElement('img', {
      src: _logo2.default,
      className: 'topbar-logo',
      alt: 'SEPS'
    })), _react2.default.createElement('div', {
      className: 'topbar-right'
    }, this.props.activarMenuPrincipal && _react2.default.createElement('a', {
      id: 'menu-button',
      onClick: this.props.onMenuButtonClick
    }, _react2.default.createElement('i', {
      className: 'fa fa-angle-left'
    })), _react2.default.createElement('a', {
      id: 'topbar-menu-button',
      onClick: this.props.onTopbarMenuButtonClick
    }, _react2.default.createElement('i', {
      className: 'fa fa-bars'
    })), _react2.default.createElement('ul', {
      className: topbarItemsClassName
    }, _react2.default.createElement('li', {
      className: (0, _classnames2.default)('profile-item', {
        'active-top-menu': this.props.activeTopbarItem === 'profile'
      }),
      onClick: function onClick(e) {
        return _this2.onTopbarItemClick(e, 'profile');
      }
    }, _react2.default.createElement('a', null, _react2.default.createElement('img', {
      alt: 'User',
      className: 'profile-image',
      src: _avatar2.default
    }), _react2.default.createElement('span', {
      className: 'topbar-item-name'
    }, tokenSeps.nombre)), _react2.default.createElement('ul', {
      className: 'layout-menu fadeInDown'
    }, mostrarCambiosSistemas && _react2.default.createElement('li', {
      role: 'menuitem'
    }, _react2.default.createElement(_reactRouterDom.Link, {
      to: '/sistemas'
    }, _react2.default.createElement('i', {
      className: 'fa fa-fw fa-user-secret'
    }), _react2.default.createElement('span', null, 'Cambiar de Sistema'))), mostrarOrganizacion && _react2.default.createElement('li', {
      role: 'menuitem'
    }, _react2.default.createElement(_reactRouterDom.Link, {
      to: '/organizaciones'
    }, _react2.default.createElement('i', {
      className: 'fa fa-fw fa-cog'
    }), _react2.default.createElement('span', null, 'Cambiar de Organizaci\xF3n'))), _react2.default.createElement('li', {
      role: 'menuitem'
    }, _react2.default.createElement(_reactRouterDom.Link, {
      to: '/login'
    }, _react2.default.createElement('i', {
      className: 'fa fa-fw fa-sign-out'
    }), _react2.default.createElement('span', null, 'Cerrar sesi\xF3n'))))), this.props.activarMenuPrincipal && _react2.default.createElement('li', {
      className: (0, _classnames2.default)('search-item')
    }, _react2.default.createElement('div', {
      className: 'titulosistema'
    }, _react2.default.createElement('span', null, 'M\xF3dulo:'), ' ', sistemaSeps.nomNombre), orgSeps && _react2.default.createElement('div', {
      className: 'tituloorg'
    }, _react2.default.createElement('span', null, 'Organizaci\xF3n:'), ' ', orgSeps.nomRazonSocial, ' - ', orgSeps.numRuc), _react2.default.createElement('div', null)))));
  };

  return Cabecera;
}(_react.Component), _class.defaultProps = {
  onMenuButtonClick: null,
  onTopbarMenuButtonClick: null,
  onTopbarItemClick: null,
  topbarMenuActive: false,
  activeTopbarItem: null,
  activarMenuPrincipal: false
}, _temp);
Cabecera.propTypes = process.env.NODE_ENV !== "production" ? {
  onMenuButtonClick: _propTypes2.default.func.isRequired,
  onTopbarMenuButtonClick: _propTypes2.default.func.isRequired,
  onTopbarItemClick: _propTypes2.default.func.isRequired,
  topbarMenuActive: _propTypes2.default.bool.isRequired,
  activeTopbarItem: _propTypes2.default.string,
  activarMenuPrincipal: _propTypes2.default.bool.isRequired
} : {};
exports.default = Cabecera;
module.exports = exports['default'];